/* `data-theme` on <html> is the single source of truth. Only the inline
 * THEME_INIT / THEME_TOGGLE scripts write it (nav-config.ts, inlined into
 * <head>/<body>). The Preact app is a pure reader — never writes the attribute —
 * to avoid a two-writer race/desync. Writers persist to `phponl_theme` so the
 * choice carries across home ↔ content ↔ playground. */

import type { Theme } from '../components/brand';

/** SSR-safe — falls back to "light" when there is no document. */
export function readTheme(): Theme {
  if (typeof document === 'undefined') return 'light';
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

/** Returns an unsubscribe fn for effect cleanup. */
export function subscribeTheme(cb: (t: Theme) => void): () => void {
  const el = document.documentElement;
  const obs = new MutationObserver(() => cb(readTheme()));
  obs.observe(el, { attributes: true, attributeFilter: ['data-theme'] });
  return () => obs.disconnect();
}
